import { TMeta } from '@cian/logger/shared';

import {
  TWebChatsSyncRequest,
  TWebChatsSyncResponse,
  fetchWebChatsSync,
} from '../../repositories/chats/v2/web/chats/sync';
import { EStatusSyncChatSchema } from '../../types/chatList';
import { TContext } from '../../types/context';
import { mapChatV2VersionToV1 } from '../../utils/v2ToV1/mapChat';

export type TSyncChatsV2ParamsRequest = Omit<TWebChatsSyncRequest, 'status'> & {
  /** Раздел чатов **/
  status?: EStatusSyncChatSchema;
};

type TSyncChatsV2Params = {
  parameters: TSyncChatsV2ParamsRequest;
  cookies?: string;
};

export async function syncChatsV2({ logger, httpApi }: TContext, { cookies, parameters }: TSyncChatsV2Params) {
  const { status } = parameters;

  const options: TWebChatsSyncRequest = {
    ...parameters,
    status: status || EStatusSyncChatSchema.Active,
  };

  try {
    const { response, statusCode }: TWebChatsSyncResponse = await fetchWebChatsSync({
      httpApi,
      parameters: options,
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode !== 200) {
      logger.warning(
        String((response as unknown as TMeta).message) || /* istanbul ignore next */ 'Код ответа не равен 200',
        {
          domain: 'src/shared/services/syncChatsV2.ts [syncChatsV2]',
          message: 'Не удалось синхронизировать список чатов',
        },
      );

      return { chats: null, movedChatIds: null };
    }

    return { chats: response.chats.map(mapChatV2VersionToV1), movedChatIds: response.movedChatIds || [] };
  } catch (error) {
    logger.error(error, {
      domain: 'src/shared/services/syncChatsV2.ts [syncChatsV2]',
      message: 'Не удалось синхронизировать список чатов',
    });

    return { chats: null, movedChatIds: null };
  }
}
